// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/plan_status.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/plan_status.proto.
 */
export const file_api_proto_v1_plan_status: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_google_protobuf_wrappers]);

/**
 * @generated from message api_proto.v1.GetOwnPlanStatusRequest
 */
export type GetOwnPlanStatusRequest = Message<"api_proto.v1.GetOwnPlanStatusRequest"> & {
};

/**
 * Describes the message api_proto.v1.GetOwnPlanStatusRequest.
 * Use `create(GetOwnPlanStatusRequestSchema)` to create a new message.
 */
export const GetOwnPlanStatusRequestSchema: GenMessage<GetOwnPlanStatusRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_plan_status, 0);

/**
 * @generated from message api_proto.v1.GetOwnPlanStatusResponse
 */
export type GetOwnPlanStatusResponse = Message<"api_proto.v1.GetOwnPlanStatusResponse"> & {
  /**
   * プラン種別ごとの契約（未契約・未移行の企業は空配列）
   *
   * @generated from field: repeated api_proto.v1.OwnContract contracts = 1;
   */
  contracts: OwnContract[];

  /**
   * クレジット状態。AIアプリ契約が無くても返す（体験クレジットの判定に使う）
   *
   * @generated from field: api_proto.v1.OwnCreditStatus credit = 2;
   */
  credit?: OwnCreditStatus;

  /**
   * 有効スタッフ数（アカウント上限メーターの分子。archived / deletedを除く）
   *
   * @generated from field: int64 active_staff_count = 3;
   */
  activeStaffCount: bigint;

  /**
   * 申し込みで選べるプラン（service_plansのis_active=trueの行のうち、申し込める段階のもの。種別 → 段階の順）。
   * 選べるかはサーバーが申し込みの入力検査（SubmitPlanInquiryのdesired_tier）と同じ関数で判定する（無料は含まない）。
   * 申し込みダイアログは段階の選択肢と段階ごとの数量（アカウント上限・付与クレジット）をこの一覧から出し、
   * 自分で段階を絞り込まない。画面にプラン定義の値や選べる段階の集合を持たせないため（SSOT）、サーバーから配る。
   *
   * @generated from field: repeated api_proto.v1.OfferedPlan offered_plans = 4;
   */
  offeredPlans: OfferedPlan[];
};

/**
 * Describes the message api_proto.v1.GetOwnPlanStatusResponse.
 * Use `create(GetOwnPlanStatusResponseSchema)` to create a new message.
 */
export const GetOwnPlanStatusResponseSchema: GenMessage<GetOwnPlanStatusResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_plan_status, 1);

/**
 * 申し込み可能なプラン1件（service_plansの表示用ビュー）
 *
 * @generated from message api_proto.v1.OfferedPlan
 */
export type OfferedPlan = Message<"api_proto.v1.OfferedPlan"> & {
  /**
   * crm / ai_app
   *
   * @generated from field: string plan_type = 1;
   */
  planType: string;

  /**
   * free / light / standard / premium / enterprise
   *
   * @generated from field: string tier = 2;
   */
  tier: string;

  /**
   * アカウント数上限の標準値（業務管理のみ。未設定(null)=契約で定める / 対象外）
   *
   * @generated from field: google.protobuf.Int64Value max_active_staffs = 3;
   */
  maxActiveStaffs?: bigint;

  /**
   * 月払い時の月次付与クレジットの標準値（営業支援のみ。未設定(null)=契約で定める / 対象外。0=付与しない）
   *
   * @generated from field: google.protobuf.Int64Value monthly_grant_credits = 4;
   */
  monthlyGrantCredits?: bigint;

  /**
   * 年払い時の期首一括付与クレジットの標準値（営業支援のみ。未設定(null)=契約で定める / 対象外。0=付与しない）
   *
   * @generated from field: google.protobuf.Int64Value yearly_grant_credits = 5;
   */
  yearlyGrantCredits?: bigint;

  /**
   * 契約ごとに数量を定めるプランか（標準の数量を持たない＝models.Plan.HasStandardQuantityの否定。サーバーが計算）
   *
   * @generated from field: bool requires_contract_quantity = 6;
   */
  requiresContractQuantity: boolean;

  /**
   * 以下の3項目は、契約で数量を定めるプラン（requires_contract_quantityが真。エンタープライズ）でだけ設定する。
   * 同じ種別で標準の数量を持つ申し込み可能なプランのうち最大の数量（サーバーがbuildOfferedPlansで計算）。
   * エンタープライズは「標準プランの最大を超える規模」なので、画面はこの値を案内文の閾値として表示するだけにする。
   * 該当するプランが無ければ未設定(null)
   * 業務管理: 標準プランのアカウント数上限の最大
   *
   * @generated from field: google.protobuf.Int64Value threshold_max_active_staffs = 7;
   */
  thresholdMaxActiveStaffs?: bigint;

  /**
   * 営業支援: 標準プランの月次付与クレジットの最大（月払いの案内に使う）
   *
   * @generated from field: google.protobuf.Int64Value threshold_monthly_grant_credits = 8;
   */
  thresholdMonthlyGrantCredits?: bigint;

  /**
   * 営業支援: 標準プランの年次付与クレジットの最大（年払いの案内に使う）
   *
   * @generated from field: google.protobuf.Int64Value threshold_yearly_grant_credits = 9;
   */
  thresholdYearlyGrantCredits?: bigint;
};

/**
 * Describes the message api_proto.v1.OfferedPlan.
 * Use `create(OfferedPlanSchema)` to create a new message.
 */
export const OfferedPlanSchema: GenMessage<OfferedPlan> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_plan_status, 2);

/**
 * 自社の契約1本（company_contracts + service_plansの表示用ビュー）
 *
 * @generated from message api_proto.v1.OwnContract
 */
export type OwnContract = Message<"api_proto.v1.OwnContract"> & {
  /**
   * crm / ai_app
   *
   * @generated from field: string plan_type = 1;
   */
  planType: string;

  /**
   * light / standard / premium / enterprise / free
   *
   * @generated from field: string tier = 2;
   */
  tier: string;

  /**
   * service_plans.name
   *
   * @generated from field: string plan_name = 3;
   */
  planName: string;

  /**
   * yearly / monthly
   *
   * @generated from field: string billing_cycle = 4;
   */
  billingCycle: string;

  /**
   * active / canceled
   *
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * 契約開始日（YYYY-MM-DD）
   *
   * @generated from field: string starts_on = 6;
   */
  startsOn: string;

  /**
   * 現期間の終了日 = 次回更新日（YYYY-MM-DD）
   *
   * @generated from field: string ends_on = 7;
   */
  endsOn: string;

  /**
   * 解約日時（RFC3339）。未解約は空文字
   *
   * @generated from field: string canceled_at = 8;
   */
  canceledAt: string;

  /**
   * アカウント数上限（CRMのみ。未設定(null)=上限なし/対象外）
   *
   * @generated from field: google.protobuf.Int64Value max_active_staffs = 9;
   */
  maxActiveStaffs?: bigint;

  /**
   * 月払い時の月次付与クレジット（AIのみ。未設定(null)=対象外）
   *
   * @generated from field: google.protobuf.Int64Value monthly_grant_credits = 10;
   */
  monthlyGrantCredits?: bigint;

  /**
   * 年払い時の期首一括付与クレジット（AIのみ。未設定(null)=対象外）
   *
   * @generated from field: google.protobuf.Int64Value yearly_grant_credits = 11;
   */
  yearlyGrantCredits?: bigint;

  /**
   * 現周期に実際に付与されたプラン付与ロットの量（AIのみ。activeな契約で現周期のロットがある場合だけ設定）。
   * プラン付与は「企業 × プラン種別 × 周期」に1ロットで、周期の途中で段階を変えても差額は付与しない
   * （go/admin_usecase/plan_grant.go）。そのため段階変更直後はmonthly/yearly_grant_credits（プラン定義の量）と
   * 食い違う。未設定(null)=現周期のロットが無い（付与対象外・解約済み・付与前）で、画面はプラン定義の量を出す。
   *
   * @generated from field: google.protobuf.Int64Value current_period_grant_credits = 12;
   */
  currentPeriodGrantCredits?: bigint;

  /**
   * クレジットを付与する（有料の）営業支援契約か。サーバーがmodels.Plan.GrantsCredits（プランの標準の付与量、
   * またはプランが標準を持たないときの契約の付与量が0より大きい）で計算する。業務管理の契約は常にfalse。
   * 無料・有料の判定はこの値で行い、段階名（tier == free）では判定しない（段階名は表示用）。
   *
   * @generated from field: optional bool grants_credits = 13;
   */
  grantsCredits?: boolean;
};

/**
 * Describes the message api_proto.v1.OwnContract.
 * Use `create(OwnContractSchema)` to create a new message.
 */
export const OwnContractSchema: GenMessage<OwnContract> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_plan_status, 3);

/**
 * 自社のクレジット状態（credit.Balanceの導出値 + 体験・失効の表示用情報）
 *
 * @generated from message api_proto.v1.OwnCreditStatus
 */
export type OwnCreditStatus = Message<"api_proto.v1.OwnCreditStatus"> & {
  /**
   * 専用の全機能分 + 汎用
   *
   * @generated from field: int64 available_total = 1;
   */
  availableTotal: bigint;

  /**
   * 汎用クレジットの残量
   *
   * @generated from field: int64 universal = 2;
   */
  universal: bigint;

  /**
   * 機能専用の残量（体験ロット含む。残量0の機能は含めない）
   *
   * @generated from field: repeated api_proto.v1.DedicatedCredit dedicated = 3;
   */
  dedicated: DedicatedCredit[];

  /**
   * 消費可能ロットのうち最も近い失効。対象が無ければ未設定(null)
   * （体験ロットの番兵期限（決定53）は除外する）
   *
   * @generated from field: api_proto.v1.NearestExpiry nearest_expiry = 5;
   */
  nearestExpiry?: NearestExpiry;

  /**
   * 当月末までに失効する消費可能クレジットの合計
   *
   * @generated from field: int64 expiring_this_month = 6;
   */
  expiringThisMonth: bigint;

  /**
   * 体験ロットを持つ機能のみ（決定77: 機能別3行）
   *
   * @generated from field: repeated api_proto.v1.TrialStatus trials = 7;
   */
  trials: TrialStatus[];

  /**
   * 機能ごとの1回あたり消費量
   *
   * @generated from field: repeated api_proto.v1.ConsumptionRate consumption_rates = 8;
   */
  consumptionRates: ConsumptionRate[];
};

/**
 * Describes the message api_proto.v1.OwnCreditStatus.
 * Use `create(OwnCreditStatusSchema)` to create a new message.
 */
export const OwnCreditStatusSchema: GenMessage<OwnCreditStatus> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_plan_status, 4);

/**
 * 機能専用クレジットの残量1件
 *
 * @generated from message api_proto.v1.DedicatedCredit
 */
export type DedicatedCredit = Message<"api_proto.v1.DedicatedCredit"> & {
  /**
   * ai.color_simulation / ai.area_estimation / ai.survey_report
   *
   * @generated from field: string permission_code = 1;
   */
  permissionCode: string;

  /**
   * @generated from field: int64 remaining = 2;
   */
  remaining: bigint;
};

/**
 * Describes the message api_proto.v1.DedicatedCredit.
 * Use `create(DedicatedCreditSchema)` to create a new message.
 */
export const DedicatedCreditSchema: GenMessage<DedicatedCredit> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_plan_status, 5);

/**
 * 直近の失効予定（決定79 C5: 最も近い失効日と、その日に失効する量）
 *
 * @generated from message api_proto.v1.NearestExpiry
 */
export type NearestExpiry = Message<"api_proto.v1.NearestExpiry"> & {
  /**
   * YYYY-MM-DD
   *
   * @generated from field: string expires_on = 1;
   */
  expiresOn: string;

  /**
   * その日に失効する消費可能クレジットの合計
   *
   * @generated from field: int64 amount = 2;
   */
  amount: bigint;
};

/**
 * Describes the message api_proto.v1.NearestExpiry.
 * Use `create(NearestExpirySchema)` to create a new message.
 */
export const NearestExpirySchema: GenMessage<NearestExpiry> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_plan_status, 6);

/**
 * 1回体験クレジットの消化状況（決定77）
 *
 * @generated from message api_proto.v1.TrialStatus
 */
export type TrialStatus = Message<"api_proto.v1.TrialStatus"> & {
  /**
   * @generated from field: string permission_code = 1;
   */
  permissionCode: string;

  /**
   * unused（残量 > 0）/ used（残量0）
   *
   * @generated from field: string state = 2;
   */
  state: string;
};

/**
 * Describes the message api_proto.v1.TrialStatus.
 * Use `create(TrialStatusSchema)` to create a new message.
 */
export const TrialStatusSchema: GenMessage<TrialStatus> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_plan_status, 7);

/**
 * 機能ごとの1回あたりクレジット消費量（決定117: 定価と期間限定の適用レート）
 *
 * @generated from message api_proto.v1.ConsumptionRate
 */
export type ConsumptionRate = Message<"api_proto.v1.ConsumptionRate"> & {
  /**
   * @generated from field: string permission_code = 1;
   */
  permissionCode: string;

  /**
   * いま適用される消費量（枠押さえに凍結される値）
   *
   * @generated from field: int64 credits = 2;
   */
  credits: bigint;

  /**
   * 定価（credit.ListRateFor）。credits と違えば期間限定の改定が効いている
   *
   * @generated from field: int64 list_credits = 3;
   */
  listCredits: bigint;

  /**
   * 期間限定の改定の理由（無ければ空）
   *
   * @generated from field: string schedule_reason = 4;
   */
  scheduleReason: string;

  /**
   * 期間限定の改定の終了（含まない）。無ければ未設定
   *
   * @generated from field: google.protobuf.Timestamp schedule_valid_to = 5;
   */
  scheduleValidTo?: Timestamp;
};

/**
 * Describes the message api_proto.v1.ConsumptionRate.
 * Use `create(ConsumptionRateSchema)` to create a new message.
 */
export const ConsumptionRateSchema: GenMessage<ConsumptionRate> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_plan_status, 8);

/**
 * @generated from message api_proto.v1.ListOwnCreditLedgerEntriesRequest
 */
export type ListOwnCreditLedgerEntriesRequest = Message<"api_proto.v1.ListOwnCreditLedgerEntriesRequest"> & {
  /**
   * 既定20・上限100
   *
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * 前ページのnext_cursor。先頭ページは空文字
   *
   * @generated from field: string cursor = 2;
   */
  cursor: string;
};

/**
 * Describes the message api_proto.v1.ListOwnCreditLedgerEntriesRequest.
 * Use `create(ListOwnCreditLedgerEntriesRequestSchema)` to create a new message.
 */
export const ListOwnCreditLedgerEntriesRequestSchema: GenMessage<ListOwnCreditLedgerEntriesRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_plan_status, 9);

/**
 * @generated from message api_proto.v1.ListOwnCreditLedgerEntriesResponse
 */
export type ListOwnCreditLedgerEntriesResponse = Message<"api_proto.v1.ListOwnCreditLedgerEntriesResponse"> & {
  /**
   * occurred_at降順
   *
   * @generated from field: repeated api_proto.v1.CreditLedgerEntry entries = 1;
   */
  entries: CreditLedgerEntry[];

  /**
   * 次ページが無ければ空文字
   *
   * @generated from field: string next_cursor = 2;
   */
  nextCursor: string;
};

/**
 * Describes the message api_proto.v1.ListOwnCreditLedgerEntriesResponse.
 * Use `create(ListOwnCreditLedgerEntriesResponseSchema)` to create a new message.
 */
export const ListOwnCreditLedgerEntriesResponseSchema: GenMessage<ListOwnCreditLedgerEntriesResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_plan_status, 10);

/**
 * クレジット台帳イベント1件（付与 / 確定消費 / 失効 / 返還）。
 * hold（枠押さえ）とreleaseは出さない（決定71）。refund（返還）は決定108(c)で追加
 * （AIカラーのマスク生成が技術的失敗で全滅した場合等、確定済み消費を後から返還する）。
 *
 * @generated from message api_proto.v1.CreditLedgerEntry
 */
export type CreditLedgerEntry = Message<"api_proto.v1.CreditLedgerEntry"> & {
  /**
   * 発生日時（RFC3339）
   *
   * @generated from field: string occurred_at = 1;
   */
  occurredAt: string;

  /**
   * grant_plan / grant_trial / grant_manual / consume / expire / refund
   *
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * consumeは消費した機能。grant / expireは専用ロットなら対象機能（汎用ロットは空文字）
   *
   * @generated from field: string permission_code = 3;
   */
  permissionCode: string;

  /**
   * 付与は正、消費・失効は負
   *
   * @generated from field: int64 amount = 4;
   */
  amount: bigint;

  /**
   * consumeのみ（company_staffs.name）。他は空文字
   *
   * @generated from field: string staff_name = 5;
   */
  staffName: string;

  /**
   * 表示ラベル（例: 月次付与 / AIカラーシミュレーションの実行 / 失効）
   *
   * @generated from field: string description = 6;
   */
  description: string;
};

/**
 * Describes the message api_proto.v1.CreditLedgerEntry.
 * Use `create(CreditLedgerEntrySchema)` to create a new message.
 */
export const CreditLedgerEntrySchema: GenMessage<CreditLedgerEntry> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_plan_status, 11);

/**
 * プランの申し込み・変更・クレジット追加希望の送信。
 * DBには保存せず営業向けの通知だけを行う（決定70）。
 *
 * @generated from message api_proto.v1.SubmitPlanInquiryRequest
 */
export type SubmitPlanInquiryRequest = Message<"api_proto.v1.SubmitPlanInquiryRequest"> & {
  /**
   * apply（未契約プランの申し込み）/ change（契約中プランの変更）/ add_credits（クレジット追加希望）
   *
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * crm / ai_app
   *
   * @generated from field: string plan_type = 2;
   */
  planType: string;

  /**
   * light / standard / premium / enterprise。add_creditsでは空可
   *
   * @generated from field: string desired_tier = 3;
   */
  desiredTier: string;

  /**
   * yearly / monthly。add_creditsでは空可
   *
   * @generated from field: string billing_cycle = 4;
   */
  billingCycle: string;

  /**
   * ご要望・ご質問（任意。2000文字まで）
   *
   * @generated from field: string message = 5;
   */
  message: string;
};

/**
 * Describes the message api_proto.v1.SubmitPlanInquiryRequest.
 * Use `create(SubmitPlanInquiryRequestSchema)` to create a new message.
 */
export const SubmitPlanInquiryRequestSchema: GenMessage<SubmitPlanInquiryRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_plan_status, 12);

/**
 * @generated from message api_proto.v1.SubmitPlanInquiryResponse
 */
export type SubmitPlanInquiryResponse = Message<"api_proto.v1.SubmitPlanInquiryResponse"> & {
};

/**
 * Describes the message api_proto.v1.SubmitPlanInquiryResponse.
 * Use `create(SubmitPlanInquiryResponseSchema)` to create a new message.
 */
export const SubmitPlanInquiryResponseSchema: GenMessage<SubmitPlanInquiryResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_plan_status, 13);

/**
 * プラン・クレジットで止められた操作の記録。サーバーが feature_block_events に1件書く。
 * 企業・スタッフは認証情報から、止められた理由・必要クレジット・残高はサーバーが記録の時点で計算する
 * （画面が持つ残高はキャッシュの写しなので送らせない）。同じスタッフ・機能・操作・画面の記録は
 * 60秒に1件に間引き、間引いたときも成功を返す。
 *
 * @generated from message api_proto.v1.RecordFeatureBlockRequest
 */
export type RecordFeatureBlockRequest = Message<"api_proto.v1.RecordFeatureBlockRequest"> & {
  /**
   * 止められた機能（権限コードのカタログにあるもの）
   *
   * @generated from field: string permission_code = 1;
   */
  permissionCode: string;

  /**
   * click（ロック表示の部品をクリックした）/ open（ロックされた画面を開いた）
   *
   * @generated from field: string action = 2;
   */
  action: string;

  /**
   * 企業画面のルート名（routeUtils/route.ts の name。英小文字・数字・ハイフン、64文字まで）
   *
   * @generated from field: string screen = 3;
   */
  screen: string;
};

/**
 * Describes the message api_proto.v1.RecordFeatureBlockRequest.
 * Use `create(RecordFeatureBlockRequestSchema)` to create a new message.
 */
export const RecordFeatureBlockRequestSchema: GenMessage<RecordFeatureBlockRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_plan_status, 14);

/**
 * @generated from message api_proto.v1.RecordFeatureBlockResponse
 */
export type RecordFeatureBlockResponse = Message<"api_proto.v1.RecordFeatureBlockResponse"> & {
};

/**
 * Describes the message api_proto.v1.RecordFeatureBlockResponse.
 * Use `create(RecordFeatureBlockResponseSchema)` to create a new message.
 */
export const RecordFeatureBlockResponseSchema: GenMessage<RecordFeatureBlockResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_plan_status, 15);

